module.exports = __webpack_public_path__ + "media/images/duel/conflict-3-ddc601b2dccade0eea418191ffc1d13d.jpg";